// Plisio Payment Gateway Integration
export const plisioService = {
  createInvoice: async (orderData) => {
    try {
      const response = await fetch('/api/create-plisio-invoice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData)
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Payment gateway error');
      }

      return {
        success: true,
        invoiceUrl: data.invoiceUrl,
        txnId: data.txnId
      };
    } catch (error) {
      console.error('Plisio invoice creation error:', error);
      throw error;
    }
  }
};
